import React, { Component } from 'react';
import Nav from 'components/common/Nav';
import { withRouter, Redirect } from 'react-router-dom';
import {
  FormGroup,
  Button,
  Row,
  Col,
  ControlLabel,
  Grid
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { load, create, update, deleteCompany } from './ducks/actions';
import './style.css';
export class CompanyForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      name: '',
      reference_id: '',
      api_key: '',
      customerId: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.save = this.save.bind(this);
    this.delete = this.delete.bind(this);
  }
  componentDidMount() {
    if (this.props.match.params.id) {
      this.props.actions.load(this.props.match.params.id);
    }
  }
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.company && nextProps.company.id) {
      this.setState({
        id: nextProps.company.id,
        name: nextProps.company.name,
        reference_id: nextProps.company.reference_id,
        customerId: nextProps.company.customerId
      });
    }
  }

  save() {
    if (this.props.match.params.id) {
      this.props.actions.update(
        this.props.match.params.id,
        this.state.customerId,
        this.state.name,
        this.state.reference_id
      );
    } else {
      this.props.actions.create(
        this.state.customerId,
        this.state.name,
        this.state.reference_id
      );
    }
  }
  delete() {
    this.props.actions.deleteCompany(this.props.match.params.id);
  }

  render() {
    var deleteBtn, apiKey;
    if (this.props.match.params.id) {
      deleteBtn = (
        <Col>
          <Button bsStyle="danger" className="pull-right" onClick={this.delete}>
            Delete
          </Button>
        </Col>
      );
    }
    if (this.props.success) {
      return (
        <Redirect
          to={{
            pathname: '/companies',
            state: { success: this.props.success }
          }}
        />
      );
    }
    if (this.props.error) {
      console.log(this.props.error);
    }

    return (
      <div>
        <Nav />
        <div className="container-fluid fe-main-wrapper">
          <div className="fe-main-content">
            <Grid fluid>
              <Row>
                <Col xs={12}>
                  <div className="page-header">
                    <h1>Company</h1>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <FormGroup>
                    <ControlLabel>Name</ControlLabel>
                    <input
                      className="form-control"
                      placeholder="Customer Name"
                      type="text"
                      name="name"
                      value={this.state.name}
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <FormGroup>
                    <ControlLabel>Reference ID</ControlLabel>
                    <input
                      className="form-control"
                      placeholder="Enter Reference ID"
                      type="text"
                      name="reference_id"
                      value={this.state.reference_id}
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <FormGroup>
                    <ControlLabel>Customer ID</ControlLabel>
                    <input
                      className="form-control"
                      placeholder="Customer ID"
                      type="text"
                      name="customerId"
                      value={this.state.customerId}
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
              {apiKey}
              <hr />
              <Row>
                <Col xs={12}>
                  <div className="btn-group pull-left">{deleteBtn}</div>
                  <div className="btn-group pull-right">
                    <Button onClick={this.props.history.goBack}>Cancel</Button>
                    <Button bsStyle="primary" onClick={this.save}>
                      Save
                    </Button>
                  </div>
                </Col>
              </Row>
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    company: state.companyReducer.company,
    success: state.companyReducer.success,
    error: state.companyReducer.error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      create: (customer_id, name, reference_id) => {
        dispatch(create(customer_id, name, reference_id));
      },
      load: id => {
        dispatch(load(id));
      },
      update: (id, customer_id, name, reference_id) => {
        dispatch(update(id, customer_id, name, reference_id));
      },
      deleteCompany: id => {
        dispatch(deleteCompany(id));
      }
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CompanyForm)
);



// WEBPACK FOOTER //
// ./src/components/companies/CompanyForm/index.js